import { render, staticRenderFns } from "./SMRejectPaymentDialog.vue?vue&type=template&id=4ebbc844&"
import script from "./SMRejectPaymentDialog.vue?vue&type=script&lang=js&"
export * from "./SMRejectPaymentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports